export default __webpack_public_path__ + "static/media/analyze.23e0bae1.png";